<template>
  <div class="content">
    <div class="content__title content__title--party content__title--start">
      <router-link :to="{ name: 'program' }" class="button button--light button--no-indent button--small">
        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.70917 13.7082C7.61629 13.8013 7.50595 13.8752 7.38447 13.9256C7.263 13.976 7.13277 14.002 7.00125 14.002C6.86973 14.002 6.7395 13.976 6.61802 13.9256C6.49655 13.8752 6.38621 13.8013 6.29332 13.7082L0.293962 7.70884C0.200846 7.61595 0.126968 7.50562 0.0765611 7.38414C0.0261537 7.26266 0.000206594 7.13243 0.000206606 7.00091C0.000206617 6.86939 0.0261537 6.73916 0.0765611 6.61769C0.126969 6.49621 0.200846 6.38587 0.293962 6.29299L6.29333 0.293626C6.48108 0.105873 6.73573 0.00039471 7.00125 0.000394734C7.26677 0.000394757 7.52142 0.105873 7.70918 0.293626C7.89693 0.481379 8.00241 0.736028 8.00241 1.00155C8.00241 1.26707 7.89693 1.52172 7.70917 1.70948L2.41574 7.00091L7.70917 12.2923C7.80229 12.3852 7.87617 12.4956 7.92658 12.617C7.97698 12.7385 8.00293 12.8688 8.00293 13.0003C8.00293 13.1318 7.97698 13.262 7.92658 13.3835C7.87617 13.505 7.80229 13.6153 7.70917 13.7082Z" fill="#2B93E7"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.00108C16 7.26627 15.8947 7.5206 15.7071 7.70811C15.5196 7.89563 15.2653 8.00098 15.0001 8.00098L2.00149 8.00098C1.7363 8.00098 1.48197 7.89563 1.29445 7.70811C1.10694 7.5206 1.00159 7.26627 1.00159 7.00108C1.00159 6.73589 1.10694 6.48156 1.29445 6.29405C1.48197 6.10653 1.7363 6.00119 2.00149 6.00119L15.0001 6.00119C15.2653 6.00119 15.5196 6.10653 15.7071 6.29405C15.8947 6.48157 16 6.73589 16 7.00108Z" fill="#2B93E7"/>
        </svg>
      </router-link>
      <h1 class="title title--big title--theme">Добавление уведомления о реализации программ и проектов</h1>
    </div>
    <form class="form" @submit.prevent>
      <div class="form__content">
        <div class="form__part">
          <div v-if="userRole === 'admin'" class="form-group">
            <label for="year">Год</label>
            <div class="form-control">
              <input id="year" type="text" class="form-control__input" name="year" v-model.trim="form.year" readonly />
            </div>
          </div>
        </div>
        <div class="form__part">
          <div v-if="userRole === 'admin'" class="form-group">
            <label>Статус<sup>*</sup></label>
            <v-select v-model="form.status" :reduce="status => status.id" :options="status_options" :get-option-label="opt => opt.name" label="name" :searchable="false" :clearable="false" placeholder="Выберите статус" class="select" :class="{'select--error': $v.form.status.$error}">
              <template slot="open-indicator">
                <svg width="18" height="18" fill="none" class="open-indicator" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="9" cy="9" r="9" fill="#2b93e7"></circle>
                  <path d="M8.6 11.82L5.16 8.05a.66.66 0 010-.87.53.53 0 01.8 0L9 10.52l3.04-3.34a.53.53 0 01.8 0c.21.24.21.63 0 .87L9.4 11.82A.53.53 0 019 12a.53.53 0 01-.4-.18z" fill="#fff"></path>
                </svg>
              </template>
              <template slot="option" slot-scope="option"><div class="select__item d-center">{{ option.name }}</div></template>
              <template slot="selected-option" slot-scope="option"><div class="selected d-center">{{ option.name }}</div></template>
            </v-select>
            <div class="form-group__error" v-if="$v.form.status.$dirty && !$v.form.status.required">Обязательное поле</div>
          </div>
        </div>
      </div>

      <div class="form__part" v-if="programs.length">
        <div class="form-group">
          <label>Федеральные программы и проекты РСМ</label>
          <div class="form__element" v-for="item in programs" :key="item.id">
            <label class="checkbox">
              <div class="checkbox__text">{{ item.name }}</div>
              <input type="checkbox" v-model="form.program" :value="item.id" />
              <div class="checkbox__checkmark"></div>
            </label>
          </div>
        </div>
      </div>
      <div v-else class="form__empty"><p>Программы не найдены</p></div>

      <div class="form__part">
        <div class="form-group">
          <label for="ro_programs">Программы и проекты РО РСМ</label>
          <textarea id="ro_programs" v-model.trim="form.ro_programs" class="form-control__input" rows="4" placeholder="Введите названия программ и проектов вашей региональной организации"></textarea>
        </div>
      </div>

      <div class="holder holder--end">
        <button v-if="userRole !== 'admin'" @click="onCheckForm('draft')" class="button button--gray" type="button" :class="{ 'preload': loading }" :disabled="$v.form.$error">
          <span>Сохранить черновик</span><img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/>
        </button>
        <button v-if="userRole !== 'admin'" @click="onCheckForm('review')" class="button" type="button" :class="{ 'preload': loading }" :disabled="$v.form.$error">
          <span>Отправить на проверку</span><img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/>
        </button>
        <button v-if="userRole === 'admin'" @click="onCheckForm(form.status)" class="button" type="button" :class="{ 'preload': loading }" :disabled="$v.form.$error">
          <span>Добавить</span><img src="@/assets/img/preloader.svg" alt="" class="button__preloader"/>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'ProgramCreate',
  mixins: [validationMixin],
  validations: {
    form: {
      year: { required },
      region_org: { required: requiredIf(function() { return !!this.userRegion }) },
      status: { required: requiredIf(function() { return this.userRole === 'admin' }) },
    },
  },
  data() {
    return {
      // ✅ СТРОГИЙ СПИСОК: точные официальные названия (нормализованные)
      allowedExactNames: [
        'федеральная программа рсм поддержки и развития молодежного творчества студвесна (российская студенческая весна)',
        'федеральная программа рсм развития социальной и гражданской активности молодежи молодежное самоуправление',
        'федеральная программа рсм выявления и поддержки лидеров в молодежной среде студент и ученик года',
        'федеральная программа рсм поддержки агромолодежи я в агро',
        'корпоративная программа рсм команда рсм'
      ],
      form: {
        year: Number(new Date().getFullYear()),
        region_org: null,
        status: null,
        program: [],
        ro_programs: '',
        comment_tech: '',
        comment_cancel: ''
      },
      loading: false,
      programs: [],
      status_options: [],
      kindNames: { 0: 'Другое', 1: 'Центральная программа «Команда РСМ»', 2: 'Выявление и поддержка талантливой молодежи', 3: 'Патриотическое воспитание молодежи', 4: 'Развитие гражданской активности молодежи', 5: 'Федеральные проекты РСМ (планируемые к разработке и утверждению)', 6: 'Команда РСМ', 7: 'Премии и конкурсы', 8: 'Гражданско-патриотические', 9: 'Развитие и самоуправление', 10: 'Прочие проекты' }
    }
  },
  computed: {
    userRegion() { return this.$store.state.organization },
    userRole() { return this.$store.state.userRole }
  },
  watch: {
    userRegion: {
      immediate: true,
      handler(val) {
        if (val !== null && val !== undefined) {
          this.form.region_org = (val && val.id !== undefined) ? val.id : val
        }
      }
    }
  },
  mounted() {
    this.loadPrograms()
    if (this.userRole === 'admin') this.loadStatuses()
  },
  methods: {
    // ✅ Нормализация для точного сравнения (убираем кавычки, лишние пробелы, регистр)
    normalize(str) {
      return (str || '').toLowerCase().replace(/[«»"'']/g, '').replace(/\s+/g, ' ').trim()
    },
    isAllowedProgram(programName) {
      const normName = this.normalize(programName)
      return this.allowedExactNames.some(allowed => normName === allowed || normName.includes(allowed))
    },
    async loadPrograms() {
      try {
        const response = await this.$store.dispatch('program/GET_SELECT')
        const rawItems = response.data?.results || response.data?.programs || response.data || []
        
        // Строгая фильтрация + удаление дублей по ID
        const filtered = rawItems.filter(p => this.isAllowedProgram(p.name))
        this.programs = filtered.filter((p, i, self) => i === self.findIndex(t => t.id === p.id))
        
        console.log('✅ Loaded programs:', this.programs.length)
      } catch (err) {
        console.error(' Error loading programs:', err)
        this.$notify({ type: 'error', title: 'Ошибка', text: 'Не удалось загрузить список программ' })
      }
    },
    async loadStatuses() {
      try {
        const res = await this.$store.dispatch('status/GET_LIST', {})
        this.status_options = res.data?.results || res.data || []
        const draft = this.status_options.find(s => s.id === 'draft' || s.code === 'draft')
        if (draft) this.form.status = draft.id
      } catch (err) { console.warn('⚠️ Статусы не загружены') }
    },
    getStatusIdByCode(code) {
      if (!code) return null
      if (typeof code === 'string' || typeof code === 'number') return code
      return this.status_options.find(s => s.code === code || s.name?.toLowerCase().includes(code.toLowerCase()))?.id || null
    },
    onCheckForm(saveType = '') {
      this.$v.form.$touch()
      const errors = []
      if (this.$v.form.year.$error) errors.push('Год')
      if (this.$v.form.region_org.$error) errors.push('Организация')
      if (this.$v.form.status.$error) errors.push('Статус')
      if (this.$v.form.$invalid) {
        this.$notify({ type: 'warn', title: 'Внимание!', text: errors.length ? `Заполните: ${errors.join(', ')}` : 'Проверьте поля' })
        return
      }
      if (saveType) {
        const statusId = this.getStatusIdByCode(saveType)
        if (statusId) this.form.status = statusId
        else if (this.userRole === 'admin') {
          this.$notify({ type: 'error', title: 'Ошибка', text: `Статус "${saveType}" не найден` })
          return
        }
      }
      this.sendForm()
    },
    async sendForm() {
  this.loading = true
  
  // ✅ Статусы в вашей БД имеют строковые ID: "draft", "review", "rejected", "accepted"
  // Убираем приведение к числу и fallback на 1
  let statusValue = this.form.status || "draft"

  const payload = {
    year: this.form.year,
    region_org: this.form.region_org || this.userRegion?.id,
    status: statusValue, // Отправляем строку, например "draft" или "review"
    program: this.form.program,
    ro_programs: this.form.ro_programs || null, 
    comment_tech: this.form.comment_tech || null,
    comment_cancel: this.form.comment_cancel || null
  }

  console.log('📤 Sending payload:', JSON.stringify(payload, null, 2))

  try {
    await this.$store.dispatch('program/POST_DATA', payload)
    this.loading = false
    this.$router.push({ name: 'program' })
    this.$notify({ type: 'success', title: 'Успех!', text: 'Уведомление добавлено.' })
  } catch (error) {
    this.loading = false
    const errorData = error?.response?.data
    
    // 🔍 Показываем ошибки валидации от DRF
    console.error('❌ Validation errors:', typeof errorData === 'object' ? errorData : 'HTML/500 response')
    
    let errorMsg = 'Ошибка добавления уведомления.'
    if (error?.response?.status === 400 && typeof errorData === 'object') {
      const messages = Object.values(errorData).flat?.().filter(Boolean) || []
      if (messages.length) errorMsg = messages.join('\n')
    } else if (error?.response?.status === 409 || errorData?.non_field_errors) {
      errorMsg = 'Запись с таким годом и организацией уже существует.'
    }
    
    this.$notify({ type: 'error', title: 'Ошибка!', text: errorMsg })
  }
},
  }
}
</script>
<style scoped>.form__empty{padding:1rem;text-align:center;color:#6c757d;background:#f8f9fa;border-radius:4px}</style>